import { PlusCircle } from 'lucide-react';
import { useSelector } from 'react-redux';
import { useEffect, useState } from 'react';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import AddMachineForm from './AddMachineForm';
import { selectUserId } from '../auth.slice';
import { IUser } from '../auth';
import useSearchParamActions from '@/customHooks/useSearchParamActions';

function AddMachineModal({ user }: { user: IUser }) {
  const currentUser = useSelector(selectUserId);
  const [dialogOpen, setDialogOpen] = useState(false);
  const { getSearchParam, removeSearchParam } = useSearchParamActions();

  useEffect(() => {
    if (getSearchParam('addMachine') === 'true') {
      setDialogOpen(true);
      removeSearchParam('addMachine');
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [getSearchParam, removeSearchParam]);

  if (!user || !currentUser || currentUser !== user._id) {
    // eslint-disable-next-line react/jsx-no-useless-fragment
    return <></>;
  }
  return (
    <Dialog open={dialogOpen} onOpenChange={setDialogOpen}>
      <DialogTrigger asChild>
        <Button className="shrink-0 px-3 sm:px-4">
          <PlusCircle className="mr-1.5 h-4 w-4 sm:mr-2" />
          Add<span className="hidden sm:inline"> Machine</span>
        </Button>
      </DialogTrigger>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Add New CNC Machine</DialogTitle>
        </DialogHeader>
        <AddMachineForm
          onSucess={() => {
            setDialogOpen(false);
          }}
        />
      </DialogContent>
    </Dialog>
  );
}

export default AddMachineModal;
